import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'

export const ContainerText = styled.div`
  color: ${Colors.Neutral90};
  ${Typography.Body}
  ${FontWeights.Medium}
`

export const Title = styled.div`
  color: ${Colors.Blue80};
  ${Typography.Subhead}
  ${FontWeights.Medium}
`
export const SubTitle = styled.div`
  color: ${Colors.Blue80};
  ${Typography.Body}
  ${FontWeights.Regular}
`
